import qs from 'qs';

/**
 * @param {string} route
 * @param {{
 *   params: Record<string, string>,
 *   queryParams: Record<string, string>
 * }} options
 */
export default function createURL(
  route = '',
  { params = {}, queryParams = {} } = {},
) {
  Object.entries(params).forEach(([key, value]) => {
    route = route.replace(`:${key}`, encodeURIComponent(value));
  });
  const queryString = qs.stringify(queryParams, {
    addQueryPrefix: true,
    skipNulls: true,
  });

  return `${route}${queryString}`;
}
